import React from "react";

const ChevronRightIcon = ({ size = "1rem" }) => {
  return (
    <svg
      className="icon bi bi-chevron-right"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
      />
    </svg>
  );
};

const ChevronDownIcon = ({ size = "1rem" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        d="M12.4993 13.8326L17.4491 8.88281L18.8633 10.297L12.4993 16.661L6.1354 10.297L7.5496 8.88281L12.4993 13.8326Z"
        fill="#E4E5E8"
      />
    </svg>
  );
};

const ChevronUpIcon = ({ size = "1rem" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 13 8"
      fill="none"
    >
      <path
        d="M6.5007 2.83147L1.55093 7.78125L0.136719 6.36703L6.5007 0.00307083L12.8646 6.36703L11.4504 7.78125L6.5007 2.83147Z"
        fill="#E4E5E8"
      />
    </svg>
  );
};

const ArrowRightIcon = () => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 16 16"
      className="icon bi bi-arrow-right"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M10.146 4.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L12.793 8l-2.647-2.646a.5.5 0 0 1 0-.708z"
      />
      <path
        fillRule="evenodd"
        d="M2 8a.5.5 0 0 1 .5-.5H13a.5.5 0 0 1 0 1H2.5A.5.5 0 0 1 2 8z"
      />
    </svg>
  );
};

const StockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      viewBox="0 0 24 24"
      width="16px"
      height="16px"
    >
      <path d="M 2.5 0 C 2.2236328 0 2 0.2236328 2 0.5 L 2 21 L 0.5 21 C 0.2236328 21 0 21.223633 0 21.5 C 0 21.776367 0.2236328 22 0.5 22 L 2 22 L 2 23.5 C 2 23.776367 2.2236328 24 2.5 24 C 2.7763672 24 3 23.776367 3 23.5 L 3 22 L 23.5 22 C 23.776367 22 24 21.776367 24 21.5 C 24 21.223633 23.776367 21 23.5 21 L 3 21 L 3 0.5 C 3 0.2236328 2.7763672 0 2.5 0 z M 21.5 1 C 20.672852 1 20 1.6728516 20 2.5 C 20 3.0418091 20.290955 3.513733 20.722656 3.7773438 L 18.712891 13.431641 L 15.8125 10.210938 C 15.928101 9.9984131 16 9.7584839 16 9.5 C 16 8.6728516 15.327148 8 14.5 8 C 13.672852 8 13 8.6728516 13 9.5 C 13 9.9790039 13.229492 10.401001 13.580078 10.675781 L 11.326172 17.435547 L 9.7480469 15.330078 C 9.9067994 15.092163 10 14.806885 10 14.5 C 10 13.672852 9.3271484 13 8.5 13 C 7.6728516 13 7 13.672852 7 14.5 C 7 14.806885 7.0932007 15.092163 7.2519531 15.330078 L 5.0996094 18.199219 C 4.9345703 18.419922 4.9785156 18.734863 5.1992188 18.900391 C 5.2890625 18.967774 5.3955078 19 5.5 19 C 5.6513672 19 5.8017578 18.932129 5.9003906 18.800781 L 8.0566406 15.925781 C 8.197876 15.969971 8.3444214 16 8.5 16 C 8.6555786 16 8.8021241 15.969971 8.9433594 15.925781 L 11.099609 18.800781 C 11.195313 18.928223 11.34375 19 11.5 19 C 11.526367 19 11.553711 18.998535 11.580078 18.994141 C 11.763672 18.964355 11.916016 18.834473 11.974609 18.658203 L 14.527344 10.998047 C 14.719971 10.994385 14.905701 10.954773 15.074219 10.884766 L 18.626953 14.833984 C 18.723633 14.940918 18.860352 15 19 15 C 19.042969 15 19.085938 14.993652 19.128906 14.982422 C 19.311514 14.933105 19.450195 14.786133 19.488281 14.601562 L 21.701172 3.9804688 C 22.43219 3.8806763 23 3.2579956 23 2.5 C 23 1.6728516 22.327148 1 21.5 1 z M 21.5 2 C 21.775391 2 22 2.2241211 22 2.5 C 22 2.7758789 21.775391 3 21.5 3 C 21.48053 3 21.464233 2.9904785 21.445312 2.9882812 C 21.429871 2.9834594 21.418518 2.9740601 21.402344 2.9707031 C 21.38562 2.9672241 21.368286 2.9724121 21.351562 2.9707031 C 21.149475 2.9066162 21 2.7232666 21 2.5 C 21 2.2241211 21.224609 2 21.5 2 z M 14.5 9 C 14.775391 9 15 9.2241211 15 9.5 C 15 9.6356812 14.945374 9.7575072 14.857422 9.8476562 C 14.84845 9.8547363 14.836731 9.8574219 14.828125 9.8652344 C 14.824768 9.8682251 14.823547 9.8719482 14.820312 9.875 C 14.732971 9.9495849 14.623474 10 14.5 10 C 14.450928 10 14.406189 9.9859009 14.361328 9.9726562 C 14.355408 9.9704589 14.351746 9.9649047 14.345703 9.9628906 C 14.330872 9.9580078 14.315735 9.9605102 14.300781 9.9570312 C 14.124329 9.8798216 14 9.704834 14 9.5 C 14 9.2241211 14.224609 9 14.5 9 z M 8.5 14 C 8.7753906 14 9 14.224121 9 14.5 C 9 14.643738 8.9371949 14.772034 8.8398438 14.863281 C 8.8236695 14.872803 8.8043824 14.875183 8.7890625 14.886719 C 8.7798462 14.893677 8.776184 14.90271 8.7675781 14.910156 C 8.6889038 14.96167 8.600708 15 8.5 15 C 8.399231 15 8.3110962 14.961731 8.2324219 14.910156 C 8.2238159 14.902771 8.2182007 14.893616 8.2089844 14.886719 C 8.1937866 14.875366 8.1761475 14.872681 8.1601562 14.863281 C 8.0625611 14.772034 8 14.643921 8 14.5 C 8 14.224121 8.2246094 14 8.5 14 z" />
    </svg>
  );
};

const FundIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      viewBox="0 0 80 80"
      width="22px"
      height="22px"
    >
      {" "}
      <path d="M 40 7 C 21.786448 7 7 21.786448 7 40 C 7 58.213552 21.786448 73 40 73 C 58.213552 73 73 58.213552 73 40 C 73 21.786448 58.213552 7 40 7 z M 40 9 C 57.132672 9 71 22.867328 71 40 C 71 57.132672 57.132672 71 40 71 C 22.867328 71 9 57.132672 9 40 C 9 22.867328 22.867328 9 40 9 z M 58 18 A 1 1 0 0 0 57 19 A 1 1 0 0 0 58 20 A 1 1 0 0 0 59 19 A 1 1 0 0 0 58 18 z M 55 21 A 1 1 0 0 0 54 22 A 1 1 0 0 0 55 23 A 1 1 0 0 0 56 22 A 1 1 0 0 0 55 21 z M 52 24 A 1 1 0 0 0 51 25 A 1 1 0 0 0 52 26 A 1 1 0 0 0 53 25 A 1 1 0 0 0 52 24 z M 38.984375 26.699219 L 38.984375 28.820312 C 34.835375 29.204312 32.316406 31.554516 32.316406 35.103516 C 32.316406 38.100516 34.191187 40.159156 37.617188 41.035156 L 38.984375 41.390625 L 38.984375 48.396484 C 36.695375 48.135484 35.220406 46.85925 35.066406 45.03125 L 31.810547 45.03125 C 31.825547 48.59625 34.591328 51.008781 38.986328 51.300781 L 38.986328 53.296875 L 41.089844 53.296875 L 41.089844 51.283203 C 45.591844 50.898203 48.189453 48.548203 48.189453 44.783203 C 48.189453 41.603203 46.375531 39.652844 42.519531 38.714844 L 41.089844 38.392578 L 41.089844 31.769531 C 43.118844 32.015531 44.5005 33.337344 44.5625 35.027344 L 47.773438 35.027344 C 47.681438 31.600344 45.068844 29.174312 41.089844 28.820312 L 41.089844 26.699219 L 38.984375 26.699219 z M 49 27 A 1 1 0 0 0 48 28 A 1 1 0 0 0 49 29 A 1 1 0 0 0 50 28 A 1 1 0 0 0 49 27 z M 38.986328 31.755859 L 38.986328 37.947266 C 36.773328 37.502266 35.604469 36.411125 35.605469 34.828125 C 35.605469 33.153125 37.019328 31.862859 38.986328 31.755859 z M 12 39 A 1 1 0 0 0 11 40 A 1 1 0 0 0 12 41 A 1 1 0 0 0 13 40 A 1 1 0 0 0 12 39 z M 16 39 A 1 1 0 0 0 15 40 A 1 1 0 0 0 16 41 A 1 1 0 0 0 17 40 A 1 1 0 0 0 16 39 z M 20 39 A 1 1 0 0 0 19 40 A 1 1 0 0 0 20 41 A 1 1 0 0 0 21 40 A 1 1 0 0 0 20 39 z M 24 39 A 1 1 0 0 0 23 40 A 1 1 0 0 0 24 41 A 1 1 0 0 0 25 40 A 1 1 0 0 0 24 39 z M 28 39 A 1 1 0 0 0 27 40 A 1 1 0 0 0 28 41 A 1 1 0 0 0 29 40 A 1 1 0 0 0 28 39 z M 41.091797 41.789062 C 43.703797 42.311062 44.917969 43.372625 44.917969 45.140625 C 44.917969 47.091625 43.519797 48.288734 41.091797 48.427734 L 41.091797 41.789062 z M 49 51 A 1 1 0 0 0 48 52 A 1 1 0 0 0 49 53 A 1 1 0 0 0 50 52 A 1 1 0 0 0 49 51 z M 52 54 A 1 1 0 0 0 51 55 A 1 1 0 0 0 52 56 A 1 1 0 0 0 53 55 A 1 1 0 0 0 52 54 z M 55 57 A 1 1 0 0 0 54 58 A 1 1 0 0 0 55 59 A 1 1 0 0 0 56 58 A 1 1 0 0 0 55 57 z M 58 60 A 1 1 0 0 0 57 61 A 1 1 0 0 0 58 62 A 1 1 0 0 0 59 61 A 1 1 0 0 0 58 60 z" />
    </svg>
  );
};

const EtfIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      viewBox="0 0 50 50"
      width="1.2rem"
      height="1.2rem"
    >
      <path d="M 35.90625 1 C 35.566406 1.0625 35.28125 1.300781 35.15625 1.625 L 34.21875 3.9375 C 31.449219 2.726563 28.390625 2.027344 25.1875 2 C 25.054688 1.972656 24.914063 1.972656 24.78125 2 C 24.769531 2 24.761719 2 24.75 2 C 12.289063 2.132813 2.183594 12.207031 2 24.65625 C 1.925781 24.867188 1.925781 25.101563 2 25.3125 C 2.167969 37.859375 12.414063 48 25 48 C 37.691406 48 48 37.691406 48 25 C 48 21.726563 47.296875 18.601563 46.0625 15.78125 L 48.375 14.84375 C 48.625 14.746094 48.824219 14.550781 48.933594 14.304688 C 49.039063 14.058594 49.039063 13.78125 48.9375 13.53125 C 46.507813 7.667969 41.90625 3.316406 36.46875 1.0625 C 36.320313 1.003906 36.160156 0.984375 36 1 C 35.96875 1 35.9375 1 35.90625 1 Z M 36.59375 3.40625 C 40.875 5.421875 44.441406 8.835938 46.59375 13.40625 L 44.8125 14.15625 C 44.800781 14.15625 44.792969 14.15625 44.78125 14.15625 C 44.449219 14.117188 44.121094 14.246094 43.90625 14.5 C 43.90625 14.511719 43.90625 14.519531 43.90625 14.53125 L 29.53125 20.46875 L 35.5625 5.90625 C 35.574219 5.886719 35.585938 5.863281 35.59375 5.84375 C 35.648438 5.757813 35.691406 5.664063 35.71875 5.5625 C 35.746094 5.503906 35.765625 5.4375 35.78125 5.375 Z M 23.90625 4.03125 C 23.9375 4.03125 23.96875 4.03125 24 4.03125 L 24 24 L 4.03125 24 C 4.53125 13.210938 13.128906 4.578125 23.90625 4.03125 Z M 26 4.03125 C 28.640625 4.152344 31.140625 4.742188 33.4375 5.75 L 26.75 21.9375 C 26.589844 22.3125 26.671875 22.75 26.960938 23.039063 C 27.25 23.328125 27.6875 23.410156 28.0625 23.25 L 44.25 16.5625 C 45.378906 19.144531 46 22 46 25 C 46 30.4375 43.914063 35.367188 40.53125 39.09375 L 26 24.5625 Z M 4.03125 26 L 24.5625 26 L 39.09375 40.53125 C 35.367188 43.914063 30.4375 46 25 46 C 13.722656 46 4.546875 37.148438 4.03125 26 Z" />
    </svg>
  );
};

const EmeraldBigGreenIcon = () => {
  return (
    <svg
      width="242"
      height="213"
      viewBox="0 0 242 213"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M144.68 84.6581C144.68 92.4328 144.649 100.203 144.706 107.978C144.715 109.452 144.301 110.524 143.298 111.649C136.168 119.659 129.144 127.761 122.058 135.81C116.167 142.499 110.215 149.136 104.328 155.829C97.439 163.661 90.6018 171.54 83.721 179.38C79.1339 184.608 74.4987 189.797 69.9028 195.021C66.1223 199.316 62.3549 203.624 58.6005 207.945C57.7415 208.931 57.2619 209.458 56.3244 207.823C48.5715 194.262 40.7271 180.753 32.887 167.24C26.9699 157.046 21.0005 146.882 15.1008 136.678C10.1473 128.106 5.27242 119.489 0.33204 110.908C-0.343828 109.735 0.0442511 109.308 1.20413 108.907C8.58635 106.347 15.9467 103.735 23.3115 101.123C32.4336 97.8877 41.5425 94.6217 50.6733 91.4081C57.5671 88.9793 64.4915 86.6421 71.381 84.2134C76.8402 82.2904 82.2603 80.2628 87.7195 78.3399C94.6047 75.9111 101.52 73.5695 108.406 71.1408C113.93 69.1917 119.424 67.1466 124.945 65.1757C130.94 63.0347 136.958 60.9374 142.953 58.7964C144.754 58.151 144.68 59.3022 144.68 60.4795C144.671 68.542 144.68 76.6044 144.676 84.6669L144.68 84.6581Z"
        fill="url(#paint0_linear_12996_105419)"
      />
      <path
        d="M241.115 109.948C235.974 118.848 231.116 127.255 226.259 135.661C212.436 159.6 198.601 183.526 184.835 207.495C183.819 209.27 183.322 209.196 182.005 207.779C163.054 187.324 144.06 166.908 125.018 146.541C123.697 145.128 123.684 144.347 124.975 142.904C132.911 134.031 140.751 125.074 148.578 116.105C149.511 115.032 150.492 114.557 151.922 114.487C179.846 113.118 207.766 111.701 235.686 110.288C237.335 110.205 238.983 110.083 241.111 109.952L241.115 109.948Z"
        fill="url(#paint1_linear_12996_105419)"
      />
      <path
        d="M1.76605 101.298C0.423033 101.08 1.08142 100.504 1.39973 99.9591C3.35757 96.5841 5.30665 93.2048 7.25577 89.8255C10.9011 83.5072 14.5246 77.1758 18.1874 70.8663C23.0101 62.5553 27.885 54.2748 32.699 45.9595C36.5013 39.3839 40.2207 32.7648 44.0099 26.1849C48.1872 18.9291 52.4343 11.7082 56.568 4.42631C57.2482 3.23155 57.7018 3.39725 58.6959 3.99463C68.8863 10.1036 79.1071 16.1559 89.3236 22.2169C99.7146 28.3869 110.001 34.7401 120.54 40.6397C126.488 43.9668 132.034 47.9173 137.977 51.2312C138.453 51.4972 139.229 51.6716 139.229 52.3257C139.229 53.1673 138.339 52.8795 137.86 53.0539C126.963 56.9521 116.053 60.8111 105.152 64.6919C93.5052 68.843 81.8847 73.0596 70.2206 77.1628C58.2163 81.3837 46.164 85.4563 34.1641 89.6816C23.6598 93.3792 13.1991 97.1902 2.71659 100.953C2.38084 101.075 2.04076 101.202 1.76605 101.302V101.298Z"
        fill="url(#paint2_linear_12996_105419)"
      />
      <path
        d="M183.806 3.56394C187.285 9.56826 190.595 15.263 193.892 20.9621C203.406 37.4096 212.921 53.8572 222.426 70.3091C228.413 80.6695 234.356 91.0604 240.378 101.399C241.503 103.331 240.182 103.012 239.105 103.069C228.958 103.601 218.811 104.146 208.665 104.661C190.473 105.589 172.277 106.47 154.089 107.464C152.088 107.573 151.665 106.976 151.674 105.084C151.744 88.8192 151.713 72.5504 151.704 56.286C151.704 55.1043 151.831 54.0273 152.498 52.972C162.592 37.0477 172.652 21.1016 182.724 5.15985C182.995 4.73689 183.287 4.32701 183.806 3.55957V3.56394Z"
        fill="url(#paint3_linear_12996_105419)"
      />
      <path
        d="M176.437 212.504H64.4046C64.156 212.046 64.4046 211.784 64.6488 211.51C82.1603 191.617 99.6892 171.743 117.135 151.794C118.526 150.202 119.176 150.315 120.523 151.772C138.833 171.542 157.203 191.255 175.557 210.991C175.888 211.348 176.367 211.623 176.437 212.5V212.504Z"
        fill="url(#paint4_linear_12996_105419)"
      />
      <path
        d="M66.3661 0.184089C67.43 0.136124 67.9141 0.0925169 68.3981 0.0925169C103.979 0.0925169 139.565 0.0925164 175.146 0.105598C175.826 0.105598 176.772 -0.28684 177.13 0.441353C177.474 1.14338 176.646 1.7146 176.271 2.30762C167.803 15.7378 159.326 29.1636 150.85 42.5893C150.461 43.2042 150.047 43.7972 149.655 44.4076C147.03 48.5021 147.047 48.4759 142.8 45.9469C124.735 35.1766 106.665 24.4238 88.5912 13.6666C81.6755 9.55031 74.7469 5.4515 67.8312 1.33524C67.4737 1.12158 67.164 0.816348 66.3617 0.179724L66.3661 0.184089Z"
        fill="url(#paint5_linear_12996_105419)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_12996_105419"
          x1="180.61"
          y1="210.609"
          x2="60.1442"
          y2="1.94935"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#55EFC4" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_12996_105419"
          x1="180.61"
          y1="210.609"
          x2="60.1438"
          y2="1.94872"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#55EFC4" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_12996_105419"
          x1="180.609"
          y1="210.61"
          x2="60.1436"
          y2="1.94954"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#55EFC4" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_12996_105419"
          x1="180.61"
          y1="210.611"
          x2="60.1439"
          y2="1.9506"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#55EFC4" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_12996_105419"
          x1="180.61"
          y1="210.611"
          x2="60.1444"
          y2="1.95152"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#55EFC4" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_12996_105419"
          x1="180.61"
          y1="210.61"
          x2="60.1437"
          y2="1.95006"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#55EFC4" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const DarkEmeraldBigGreenIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="242"
      height="213"
      viewBox="0 0 242 213"
      fill="none"
    >
      <path
        d="M144.68 84.6584C144.68 92.433 144.649 100.203 144.706 107.978C144.715 109.452 144.301 110.524 143.298 111.649C136.168 119.66 129.144 127.761 122.058 135.811C116.167 142.5 110.215 149.136 104.328 155.829C97.439 163.661 90.6018 171.54 83.721 179.38C79.1339 184.608 74.4987 189.797 69.9028 195.021C66.1223 199.316 62.3549 203.624 58.6005 207.945C57.7415 208.931 57.2619 209.458 56.3244 207.823C48.5715 194.262 40.7271 180.754 32.887 167.241C26.9699 157.046 21.0005 146.882 15.1008 136.678C10.1473 128.106 5.27242 119.49 0.33204 110.908C-0.343828 109.735 0.0442511 109.308 1.20413 108.907C8.58635 106.347 15.9467 103.735 23.3115 101.123C32.4336 97.888 41.5425 94.622 50.6733 91.4083C57.5671 88.9796 64.4915 86.6424 71.381 84.2136C76.8402 82.2907 82.2603 80.2631 87.7195 78.3401C94.6047 75.9114 101.52 73.5698 108.406 71.141C113.93 69.1919 119.424 67.1469 124.945 65.176C130.94 63.035 136.958 60.9376 142.953 58.7966C144.754 58.1513 144.68 59.3024 144.68 60.4798C144.671 68.5422 144.68 76.6047 144.676 84.6671L144.68 84.6584Z"
        fill="url(#paint0_linear_13299_150370)"
      />
      <path
        d="M241.115 109.948C235.974 118.847 231.116 127.254 226.259 135.661C212.436 159.6 198.601 183.526 184.835 207.495C183.819 209.27 183.322 209.196 182.005 207.779C163.054 187.324 144.06 166.908 125.018 146.541C123.697 145.128 123.684 144.347 124.975 142.904C132.911 134.03 140.751 125.074 148.578 116.105C149.511 115.032 150.492 114.557 151.922 114.487C179.846 113.118 207.766 111.701 235.686 110.288C237.335 110.205 238.983 110.083 241.111 109.952L241.115 109.948Z"
        fill="url(#paint1_linear_13299_150370)"
      />
      <path
        d="M1.76605 101.298C0.423033 101.08 1.08142 100.504 1.39973 99.9591C3.35757 96.5841 5.30665 93.2048 7.25577 89.8255C10.9011 83.5072 14.5246 77.1758 18.1874 70.8663C23.0101 62.5553 27.885 54.2748 32.699 45.9595C36.5013 39.3839 40.2207 32.7648 44.0099 26.1849C48.1872 18.9291 52.4343 11.7082 56.568 4.42631C57.2482 3.23155 57.7018 3.39725 58.6959 3.99463C68.8863 10.1036 79.1071 16.1559 89.3236 22.2169C99.7146 28.3869 110.001 34.7401 120.54 40.6397C126.488 43.9668 132.034 47.9173 137.977 51.2312C138.453 51.4972 139.229 51.6716 139.229 52.3257C139.229 53.1673 138.339 52.8795 137.86 53.0539C126.963 56.9521 116.053 60.8111 105.152 64.6919C93.5052 68.843 81.8847 73.0596 70.2206 77.1628C58.2163 81.3837 46.164 85.4563 34.1641 89.6816C23.6598 93.3792 13.1991 97.1902 2.71659 100.953C2.38084 101.075 2.04076 101.202 1.76605 101.302V101.298Z"
        fill="url(#paint2_linear_13299_150370)"
      />
      <path
        d="M183.806 3.56394C187.285 9.56826 190.595 15.263 193.892 20.9621C203.406 37.4096 212.921 53.8572 222.426 70.3091C228.413 80.6695 234.356 91.0604 240.378 101.399C241.503 103.331 240.182 103.012 239.105 103.069C228.958 103.601 218.811 104.146 208.665 104.661C190.473 105.589 172.277 106.47 154.089 107.464C152.088 107.573 151.665 106.976 151.674 105.084C151.744 88.8192 151.713 72.5504 151.704 56.286C151.704 55.1043 151.831 54.0273 152.498 52.972C162.592 37.0477 172.652 21.1016 182.724 5.15985C182.995 4.73689 183.287 4.32701 183.806 3.55957V3.56394Z"
        fill="url(#paint3_linear_13299_150370)"
      />
      <path
        d="M176.437 212.504H64.4046C64.156 212.046 64.4046 211.784 64.6488 211.509C82.1603 191.617 99.6892 171.742 117.135 151.793C118.526 150.202 119.176 150.315 120.523 151.771C138.833 171.542 157.203 191.255 175.557 210.991C175.888 211.348 176.367 211.623 176.437 212.499V212.504Z"
        fill="url(#paint4_linear_13299_150370)"
      />
      <path
        d="M66.3661 0.184089C67.43 0.136124 67.9141 0.0925169 68.3981 0.0925169C103.979 0.0925169 139.565 0.0925164 175.146 0.105598C175.826 0.105598 176.772 -0.28684 177.13 0.441353C177.474 1.14338 176.646 1.7146 176.271 2.30762C167.803 15.7378 159.326 29.1636 150.85 42.5893C150.461 43.2042 150.047 43.7972 149.655 44.4076C147.03 48.5021 147.047 48.4759 142.8 45.9469C124.735 35.1766 106.665 24.4238 88.5912 13.6666C81.6755 9.55031 74.7469 5.4515 67.8312 1.33524C67.4737 1.12158 67.164 0.816348 66.3617 0.179724L66.3661 0.184089Z"
        fill="url(#paint5_linear_13299_150370)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_13299_150370"
          x1="180.61"
          y1="210.61"
          x2="60.1442"
          y2="1.94959"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#55EFC4" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_13299_150370"
          x1="180.61"
          y1="210.608"
          x2="60.1438"
          y2="1.94848"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#55EFC4" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_13299_150370"
          x1="180.609"
          y1="210.61"
          x2="60.1436"
          y2="1.94954"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#55EFC4" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_13299_150370"
          x1="180.61"
          y1="210.611"
          x2="60.1439"
          y2="1.9506"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#55EFC4" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_13299_150370"
          x1="180.61"
          y1="210.611"
          x2="60.1444"
          y2="1.95128"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#55EFC4" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_13299_150370"
          x1="180.61"
          y1="210.61"
          x2="60.1437"
          y2="1.95006"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#55EFC4" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const EmeraldBigTextIcon = ({ fill }) => {
  return (
    <svg
      width="436"
      height="58"
      viewBox="0 0 436 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.6073 57.6267H1.79155C0.785604 57.6267 0.11499 56.9561 0.11499 55.9501V2.59209C0.11499 1.58614 0.785604 0.915527 1.79155 0.915527H31.4492C32.5407 0.915527 33.1258 1.50053 33.1258 2.59209V4.76811C33.1258 5.85967 32.5407 6.44467 31.4492 6.44467H5.97943V26.0499H29.7726C30.8642 26.0499 31.4492 26.635 31.4492 27.7265V29.824C31.4492 30.9156 30.8642 31.5006 29.7726 31.5006H5.97943V52.1047H32.1127C33.2827 52.1047 33.8677 52.861 33.4539 54.031L32.6977 56.1285C32.3624 57.1344 31.6917 57.6338 30.6002 57.6338L30.6073 57.6267Z"
        fill={fill}
      />
      <path
        d="M55.8204 55.6144L64.5314 2.33483C64.7027 1.32889 65.4518 0.907959 66.2081 0.907959C67.0428 0.907959 67.4637 1.07921 67.9702 1.91393L87.4043 43.7142L106.674 1.99954C107.095 1.16482 107.68 0.907959 108.436 0.907959C109.271 0.907959 109.942 1.32888 110.199 2.4133L118.824 55.6072C118.995 56.9485 118.403 57.6191 117.147 57.6191H114.886C113.794 57.6191 113.124 57.1197 112.96 55.9426L106.51 15.8188L88.7527 53.8522C88.503 54.4372 88.082 54.7725 87.4114 54.7725C86.6552 54.7725 86.3198 54.4372 85.9845 53.7666L68.2271 15.8188L61.7776 55.9426C61.6135 57.1126 60.8572 57.6191 59.7657 57.6191H57.5041C56.3341 57.6191 55.6634 56.9485 55.8275 55.6072L55.8204 55.6144Z"
        fill={fill}
      />
      <path
        d="M173.937 57.6267H145.121C144.115 57.6267 143.445 56.9561 143.445 55.9501V2.59209C143.445 1.58614 144.115 0.915527 145.121 0.915527H174.779C175.87 0.915527 176.455 1.50053 176.455 2.59209V4.76811C176.455 5.85967 175.87 6.44467 174.779 6.44467H149.309V26.0499H173.102C174.194 26.0499 174.779 26.635 174.779 27.7265V29.824C174.779 30.9156 174.194 31.5006 173.102 31.5006H149.309V52.1047H175.442C176.612 52.1047 177.197 52.861 176.784 54.031L176.027 56.1285C175.692 57.1344 175.021 57.6338 173.93 57.6338L173.937 57.6267Z"
        fill={fill}
      />
      <path
        d="M202.254 55.9501V2.59209C202.254 1.50053 202.839 0.915527 203.93 0.915527H221.274C231.911 0.915527 238.696 7.95002 238.696 17.503C238.696 25.7146 232.667 32.4994 223.871 33.0845L239.031 55.6148C239.787 56.7064 239.281 57.6267 237.94 57.6267H235.007C234.173 57.6267 233.416 57.2914 232.91 56.5352L215.573 30.4019C214.817 29.3104 215.324 28.39 216.665 28.39H220.689C228.815 28.39 232.839 23.1962 232.839 17.503C232.839 11.4744 228.651 6.44467 220.946 6.44467H208.132V55.9501C208.132 57.0417 207.547 57.6267 206.456 57.6267H203.944C202.853 57.6267 202.268 57.0417 202.268 55.9501H202.254Z"
        fill={fill}
      />
      <path
        d="M258.887 55.7859L283.679 1.422C284.1 0.501667 284.513 0.251953 285.355 0.251953C286.197 0.251953 286.611 0.501667 287.032 1.422L311.824 55.7859C312.323 56.7919 311.824 57.6266 310.654 57.6266H307.721C306.715 57.6266 305.881 57.2057 305.46 56.1997L299.26 42.1236H271.279L265.079 56.1997C264.658 57.2057 263.824 57.6266 262.732 57.6266H260.05C258.88 57.6266 258.373 56.7919 258.88 55.7859H258.887ZM296.749 36.6801L285.27 11.0463L273.79 36.6801H296.742H296.749Z"
        fill={fill}
      />
      <path
        d="M333.354 55.9501V2.59209C333.354 1.50053 333.939 0.915527 335.031 0.915527H337.542C338.634 0.915527 339.219 1.50053 339.219 2.59209V52.0975H363.932C365.102 52.0975 365.687 52.7682 365.274 53.9382L364.439 56.2854C364.104 57.1201 363.519 57.6267 362.513 57.6267H335.038C333.947 57.6267 333.362 57.0417 333.362 55.9501H333.354Z"
        fill={fill}
      />
      <path
        d="M389.48 55.9501V2.59209C389.48 1.50053 390.065 0.915527 391.157 0.915527H406.232C422.734 0.915527 435.219 12.8941 435.219 29.3103C435.219 45.7265 422.07 57.6267 406.988 57.6267H405.397C404.391 57.6267 403.806 57.1273 403.471 56.2854L402.636 53.9382C402.215 52.7682 402.807 52.0975 403.892 52.0975H406.403C419.217 52.0975 429.105 42.7159 429.105 29.2319C429.105 15.7479 419.302 6.44467 406.068 6.44467H395.345V55.9501C395.345 57.0417 394.76 57.6267 393.668 57.6267H391.157C390.065 57.6267 389.48 57.0417 389.48 55.9501Z"
        fill={fill}
      />
    </svg>
  );
};

const IncomeAlertsTextIcon = ({ fill }) => {
  return (
    <svg
      width="434"
      height="33"
      viewBox="0 0 434 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.59539 0.832275V31.7098H0.777344V0.832275H3.59539Z"
        fill={fill}
      />
      <path
        d="M44.3402 0.832275V31.7098H41.5934L23.3508 5.84772H23.1082V31.7098H20.2902V0.832275H23.0226L41.3294 26.7229H41.572V0.832275H44.3473H44.3402Z"
        fill={fill}
      />
      <path
        d="M85.2198 10.4858H82.3875C82.1734 9.42996 81.7953 8.45256 81.246 7.55363C80.6966 6.6547 80.0117 5.86992 79.1913 5.19215C78.3637 4.52152 77.4291 3.99357 76.3875 3.62258C75.3459 3.25159 74.2115 3.06612 72.9986 3.06612C71.051 3.06612 69.2745 3.57267 67.6692 4.58575C66.064 5.59883 64.787 7.08988 63.8238 9.05897C62.8607 11.0209 62.3827 13.4252 62.3827 16.2719C62.3827 19.1185 62.8607 21.5513 63.8238 23.5061C64.787 25.468 66.064 26.952 67.6692 27.9651C69.2745 28.9782 71.051 29.4776 72.9986 29.4776C74.2115 29.4776 75.3459 29.2921 76.3875 28.9211C77.4362 28.5501 78.3708 28.0293 79.1913 27.3587C80.0189 26.688 80.7038 25.9033 81.246 24.9972C81.7953 24.0911 82.1734 23.1137 82.3875 22.0578H85.2198C84.9701 23.4776 84.4993 24.7974 83.8072 26.0174C83.1152 27.2374 82.2448 28.3075 81.1818 29.2207C80.1187 30.1339 78.9059 30.8474 77.529 31.361C76.152 31.8747 74.6395 32.1316 72.9915 32.1316C70.3946 32.1316 68.0973 31.4824 66.0854 30.1768C64.0735 28.8783 62.4968 27.0376 61.3553 24.669C60.2138 22.3004 59.6431 19.4966 59.6431 16.2719C59.6431 13.0471 60.2138 10.2433 61.3553 7.87468C62.4968 5.49894 64.0735 3.66542 66.0854 2.36697C68.0973 1.06137 70.3946 0.412109 72.9915 0.412109C74.6395 0.412109 76.152 0.668952 77.529 1.17549C78.9059 1.68203 80.1259 2.39547 81.1818 3.31581C82.2448 4.23614 83.1152 5.30629 83.8072 6.51914C84.4921 7.73911 84.963 9.05897 85.2198 10.4858Z"
        fill={fill}
      />
      <path
        d="M125.658 16.2711C125.658 19.4888 125.087 22.2854 123.938 24.6612C122.79 27.0369 121.22 28.8776 119.208 30.176C117.203 31.4816 114.899 32.1309 112.295 32.1309C109.691 32.1309 107.386 31.4816 105.382 30.176C103.377 28.8776 101.8 27.0369 100.666 24.6612C99.5243 22.2854 98.9536 19.4888 98.9536 16.2711C98.9536 13.0535 99.5243 10.2569 100.666 7.88111C101.807 5.50536 103.384 3.6647 105.396 2.35911C107.408 1.05352 109.705 0.404297 112.302 0.404297C114.899 0.404297 117.21 1.05352 119.215 2.35911C121.22 3.65757 122.797 5.49823 123.945 7.88111C125.094 10.2569 125.665 13.0535 125.665 16.2711H125.658ZM122.918 16.2711C122.918 13.5101 122.454 11.1344 121.534 9.16529C120.606 7.18907 119.351 5.6766 117.753 4.63498C116.155 3.58622 114.342 3.06541 112.309 3.06541C110.276 3.06541 108.478 3.58622 106.88 4.63498C105.282 5.6766 104.019 7.18906 103.084 9.15815C102.157 11.1272 101.686 13.503 101.686 16.2783C101.686 19.0536 102.15 21.4079 103.07 23.377C103.998 25.3461 105.253 26.8586 106.851 27.9073C108.449 28.9561 110.262 29.484 112.295 29.484C114.328 29.484 116.14 28.9632 117.746 27.9145C119.351 26.8728 120.614 25.3603 121.541 23.3841C122.469 21.4079 122.925 19.0393 122.911 16.2783L122.918 16.2711Z"
        fill={fill}
      />
      <path
        d="M140.968 0.832275H144.221L155.422 27.7289H155.693L166.894 0.832275H170.147V31.7098H167.493V6.78232H167.251L156.835 31.7098H154.273L143.857 6.78232H143.615V31.7098H140.961V0.832275H140.968Z"
        fill={fill}
      />
      <path
        d="M186.849 31.7098V0.832275H204.764V3.36497H189.674V14.9869H203.815V17.5196H189.674V29.1771H205.07V31.7098H186.856H186.849Z"
        fill={fill}
      />
      <path
        d="M241.02 31.7098H238.067L249.303 0.832275H252.321L263.558 31.7098H260.604L250.923 4.49221H250.709L241.027 31.7098H241.02ZM243.146 19.8739H258.464V22.4066H243.146V19.8739Z"
        fill={fill}
      />
      <path
        d="M277.327 31.7098V0.832275H280.145V29.1771H294.863V31.7098H277.327Z"
        fill={fill}
      />
      <path
        d="M309.703 31.7098V0.832275H327.617V3.36497H312.521V14.9869H326.661V17.5196H312.521V29.1771H327.917V31.7098H309.703Z"
        fill={fill}
      />
      <path
        d="M343.392 31.7098V0.832275H353.358C355.549 0.832275 357.382 1.22465 358.852 2.01656C360.322 2.80848 361.434 3.89292 362.184 5.29126C362.933 6.68247 363.304 8.28058 363.304 10.0784C363.304 11.8763 362.926 13.4673 362.184 14.8442C361.434 16.2211 360.329 17.2984 358.859 18.0689C357.389 18.8466 355.57 19.2318 353.401 19.2318H344.911V16.6563H353.323C354.928 16.6563 356.269 16.3924 357.339 15.8573C358.41 15.3222 359.209 14.5659 359.736 13.5814C360.264 12.5969 360.528 11.4339 360.528 10.0855C360.528 8.73715 360.264 7.56 359.729 6.54692C359.194 5.53384 358.395 4.75616 357.325 4.19968C356.255 3.65033 354.906 3.37211 353.28 3.37211H346.21V31.717H343.392V31.7098ZM357.004 17.7764L364.602 31.7098H361.349L353.822 17.7764H357.004Z"
        fill={fill}
      />
      <path
        d="M376.809 3.36497V0.832275H399.197V3.36497H389.408V31.7098H386.59V3.36497H376.802H376.809Z"
        fill={fill}
      />
      <path
        d="M430.788 8.55175C430.616 6.83236 429.86 5.46256 428.512 4.44948C427.163 3.4364 425.473 2.92985 423.432 2.92985C421.991 2.92985 420.728 3.17954 419.637 3.67181C418.545 4.16408 417.689 4.84184 417.075 5.71223C416.462 6.58263 416.148 7.56719 416.148 8.67302C416.148 9.48634 416.326 10.1998 416.676 10.8133C417.025 11.4269 417.503 11.9548 418.103 12.39C418.702 12.8252 419.366 13.2033 420.093 13.5172C420.821 13.8312 421.556 14.088 422.305 14.3021L425.558 15.2367C426.543 15.5078 427.527 15.8574 428.512 16.2783C429.496 16.6992 430.402 17.2271 431.216 17.8692C432.036 18.5113 432.693 19.289 433.192 20.2093C433.691 21.1296 433.941 22.2283 433.941 23.5197C433.941 25.1677 433.513 26.6516 432.657 27.9644C431.801 29.2842 430.574 30.3259 428.976 31.0964C427.377 31.8669 425.465 32.2521 423.232 32.2521C421.128 32.2521 419.308 31.9026 417.76 31.2034C416.212 30.5042 414.992 29.5411 414.108 28.2997C413.223 27.0655 412.723 25.6314 412.616 24.0048H415.513C415.613 25.2176 416.012 26.2521 416.719 27.094C417.425 27.9358 418.338 28.5779 419.465 29.0131C420.593 29.4483 421.848 29.6695 423.232 29.6695C424.773 29.6695 426.143 29.4127 427.342 28.8919C428.54 28.3711 429.489 27.6505 430.174 26.723C430.866 25.7955 431.209 24.7111 431.209 23.4769C431.209 22.4352 430.937 21.5577 430.395 20.8443C429.853 20.138 429.097 19.5387 428.127 19.0607C427.156 18.5755 426.036 18.1475 424.759 17.7765L421.064 16.6921C418.638 15.9715 416.761 14.9656 415.427 13.6885C414.093 12.4115 413.423 10.7848 413.423 8.80143C413.423 7.13912 413.865 5.6837 414.757 4.42091C415.649 3.15813 416.854 2.17362 418.374 1.46731C419.893 0.761009 421.606 0.404297 423.511 0.404297C425.416 0.404297 427.128 0.753867 428.605 1.46017C430.081 2.16647 431.259 3.12962 432.122 4.36387C432.992 5.59812 433.456 6.99642 433.52 8.56598H430.788V8.55175Z"
        fill={fill}
      />
    </svg>
  );
};

const EmeraldBenefitCheckIcon = ({ fill, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="30"
      viewBox="0 0 29 30"
      fill="none"
    >
      <rect y="0.503906" width="29" height="29" rx="10" fill={fill} />
      <rect
        x="18.071"
        y="12.6252"
        width="2"
        height="7"
        rx="1"
        transform="rotate(45 18.071 12.6252)"
        fill={color}
      />
      <rect
        x="15.9497"
        y="17.575"
        width="2"
        height="5"
        rx="1"
        transform="rotate(135 15.9497 17.575)"
        fill={color}
      />
    </svg>
  );
};

const CalendarIcon = ({ onClick, fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      onClick={onClick}
    >
      <path
        d="M7.50008 0.835938V2.5026H12.5001V0.835938H14.1667V2.5026H17.5001C17.9603 2.5026 18.3334 2.8757 18.3334 3.33594V16.6693C18.3334 17.1295 17.9603 17.5026 17.5001 17.5026H2.50008C2.03985 17.5026 1.66675 17.1295 1.66675 16.6693V3.33594C1.66675 2.8757 2.03985 2.5026 2.50008 2.5026H5.83341V0.835938H7.50008ZM16.6667 9.16927H3.33341V15.8359H16.6667V9.16927ZM5.83341 4.16927H3.33341V7.5026H16.6667V4.16927H14.1667V5.83594H12.5001V4.16927H7.50008V5.83594H5.83341V4.16927Z"
        fill={fill}
      />
    </svg>
  );
};

const CryptoObsidianIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M15 30C12.925 30 10.975 29.6063 9.15 28.8188C7.325 28.0313 5.7375 26.9625 4.3875 25.6125C3.0375 24.2625 1.96875 22.675 1.18125 20.85C0.39375 19.025 0 17.075 0 15C0 12.925 0.39375 10.975 1.18125 9.15C1.96875 7.325 3.0375 5.7375 4.3875 4.3875C5.7375 3.0375 7.325 1.96875 9.15 1.18125C10.975 0.39375 12.925 0 15 0C17.075 0 19.025 0.39375 20.85 1.18125C22.675 1.96875 24.2625 3.0375 25.6125 4.3875C26.9625 5.7375 28.0313 7.325 28.8188 9.15C29.6063 10.975 30 12.925 30 15C30 17.075 29.6063 19.025 28.8188 20.85C28.0313 22.675 26.9625 24.2625 25.6125 25.6125C24.2625 26.9625 22.675 28.0313 20.85 28.8188C19.025 29.6063 17.075 30 15 30ZM13.875 27.7125V25.275C12.85 25.15 11.8875 24.9 10.9875 24.525C10.0875 24.15 9.2625 23.6625 8.5125 23.0625L6.7875 24.7875C7.7625 25.6125 8.85 26.275 10.05 26.775C11.25 27.275 12.525 27.5875 13.875 27.7125ZM16.125 27.7125C17.475 27.5875 18.75 27.275 19.95 26.775C21.15 26.275 22.2375 25.6125 23.2125 24.7875L21.4875 23.0625C20.7375 23.6625 19.9125 24.15 19.0125 24.525C18.1125 24.9 17.15 25.15 16.125 25.275V27.7125ZM15 23.1375C17.275 23.1375 19.2 22.35 20.775 20.775C22.35 19.2 23.1375 17.275 23.1375 15C23.1375 12.725 22.35 10.8 20.775 9.225C19.2 7.65 17.275 6.8625 15 6.8625C12.725 6.8625 10.8 7.65 9.225 9.225C7.65 10.8 6.8625 12.725 6.8625 15C6.8625 17.275 7.65 19.2 9.225 20.775C10.8 22.35 12.725 23.1375 15 23.1375ZM24.7875 23.2125C25.6125 22.2375 26.275 21.15 26.775 19.95C27.275 18.75 27.5875 17.475 27.7125 16.125H25.275C25.15 17.15 24.9 18.1125 24.525 19.0125C24.15 19.9125 23.6625 20.7375 23.0625 21.4875L24.7875 23.2125ZM5.2125 23.2125L6.9375 21.4875C6.3375 20.7375 5.85 19.9125 5.475 19.0125C5.1 18.1125 4.85 17.15 4.725 16.125H2.2875C2.4125 17.475 2.725 18.75 3.225 19.95C3.725 21.15 4.3875 22.2375 5.2125 23.2125ZM2.2875 13.875H4.725C4.85 12.85 5.1 11.8875 5.475 10.9875C5.85 10.0875 6.3375 9.2625 6.9375 8.5125L5.2125 6.7875C4.3875 7.7625 3.725 8.85 3.225 10.05C2.725 11.25 2.4125 12.525 2.2875 13.875ZM25.275 13.875H27.7125C27.5875 12.525 27.275 11.25 26.775 10.05C26.275 8.85 25.6125 7.7625 24.7875 6.7875L23.0625 8.5125C23.6625 9.2625 24.15 10.0875 24.525 10.9875C24.9 11.8875 25.15 12.85 25.275 13.875ZM8.5125 6.9375C9.2625 6.3375 10.0875 5.85 10.9875 5.475C11.8875 5.1 12.85 4.85 13.875 4.725V2.2875C12.525 2.4125 11.25 2.725 10.05 3.225C8.85 3.725 7.7625 4.3875 6.7875 5.2125L8.5125 6.9375ZM21.4875 6.9375L23.2125 5.2125C22.2375 4.3875 21.15 3.725 19.95 3.225C18.75 2.725 17.475 2.4125 16.125 2.2875V4.725C17.15 4.85 18.1125 5.1 19.0125 5.475C19.9125 5.85 20.7375 6.3375 21.4875 6.9375Z"
        fill={fill}
        fillOpacity="0.56"
      />
    </svg>
  );
};

export {
  ArrowRightIcon,
  ChevronRightIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  EtfIcon,
  FundIcon,
  StockIcon,
  EmeraldBigGreenIcon,
  DarkEmeraldBigGreenIcon,
  EmeraldBigTextIcon,
  IncomeAlertsTextIcon,
  EmeraldBenefitCheckIcon,
  CalendarIcon,
  CryptoObsidianIcon,
};
